import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hydrate when the HTML was pre-rendered at build time (scripts/prerender.js
// writes each route's index.html); otherwise mount fresh (dev server).
// react-query was removed 2026-09-01 — the app never used it.
const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
